import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Investisseur } from '@lib/models/generated/graphql';
import { AbstractPaginatedTableComponent } from 'finzzle-angular-utils';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';

@Component({
  selector: 'app-add-relation-table',
  imports: [SHARED_IMPORTS],
  templateUrl: './add-relation-table.component.html',
  styleUrl: './add-relation-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRelationTableComponent extends AbstractPaginatedTableComponent<Investisseur> {
  public tooltipName = input<string | undefined>('');
  public isReadOnly = input<boolean>(false);
  readonly relatedPersonnePhysiqueIds = input<number[] | undefined>([]);
  readonly relatedPersonneTooltip = input<string>('Vous avez déjà ajouté cette relation');
  readonly doubleRelationAllowed = input<boolean>(false);
  readonly addRelation = output<Investisseur>();
  readonly displayedColumns = ['type', 'nom', 'dateNaissance', 'option'];
  constructor() {
    super();
  }

  public selectInvestisseur(investisseur: Investisseur): void {
    this.addRelation.emit(investisseur);
  }

  public isRelation(personnePhysiqueId: number): boolean {
    return (
      !this.doubleRelationAllowed() &&
      this.relatedPersonnePhysiqueIds() !== undefined &&
      this.relatedPersonnePhysiqueIds()!.includes(personnePhysiqueId)
    );
  }
}
